import { IPanelStyles, Pivot, Text } from "@fluentui/react";

export const stickyFooterPanelStyles: Partial<IPanelStyles> = {
  footer: {
    borderTop: '1px solid #e5e5e5',
  },
  content: {
    overflowX: 'hidden',
  },
};

export const PanelHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PanelHeaderTitleText = styled(Text)`
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  color: #171717;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 48px;
  padding-right: 48px;
`;

export const PivotStyled = styled(Pivot)`
  display: flex;
  margin-left: 40px;
`;

export const HeaderDivider = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  margin-top: -6px;
`;

export const SearchBoxContainer = styled.div`
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 48px;
  padding-right: 48px; 
  border-bottom: 1px solid #e5e5e5;
`;

export const ViewRequestContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BasicDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
  row-gap: 20px;
`;

export const CdmDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
  row-gap: 20px;
`;

export const RuleSetsDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
  row-gap: 20px;
`;

export const SubSectionalHeading = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const SubSectionalHeadingText = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #323130;
`;

export const LineDivider = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e5e5;
`;

export const BasicDetailsSection = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BasicDetailsField = styled(Text)`
  width: 35%;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #171717;
`;

export const BasicDetailsValue = styled(Text)`
  width: 65%;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #646464;
`;

export const AttachmentsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const AttachmentText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  color: #0078d4;
  cursor: pointer;
`;
